var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTelegram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.93689 19.8738C15.4249 19.8738 19.8738 15.4249 19.8738 9.93689C19.8738 4.4489 15.4249 0 9.93689 0C4.4489 0 0 4.4489 0 9.93689C0 15.4249 4.4489 19.8738 9.93689 19.8738Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.54698 9.72167L14.1278 6.02763C14.5725 5.86699 14.9608 6.13611 14.8168 6.80851L14.8176 6.80768L13.1863 14.493C13.0654 15.0379 12.7416 15.1704 12.2886 14.9137L9.80442 13.0828L8.6062 14.2372C8.47371 14.3697 8.36192 14.4814 8.10522 14.4814L8.2816 11.9533L12.8857 7.79392C13.0861 7.61754 12.841 7.51817 12.5768 7.69372L6.88712 11.276L4.43436 10.5108C3.90191 10.3419 3.89032 9.97838 4.54698 9.72167Z",
    fill: "#2F2E41"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/Telegram.bbee910e141f925674b7b9994e2c8b92.svg";
export { ForwardRef as ReactComponent };